import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Hospital } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

import { UseGetAllPageSizeProps } from '../types';

export const GET_ALL_HOSPITALS_KEY = 'get-all-hospitals';

export const useGetAllHospitals = ({ page = 0, size = 10 }: UseGetAllPageSizeProps) =>
  usePermittedQuery<Hospital[]>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () => `/hospital?page=${page}&size=${size}`,
    {},
    [GET_ALL_HOSPITALS_KEY],
    {
      enabled:
        typeof page === 'number' && typeof size === 'number' && page >= 0 && size >= 0,
      refetchOnWindowFocus: false,
    },
  );
